
export const OptionTradeTitle = "tfOptionTradeTitle";

export function optionTradeTitle() {
    return {
        template,
        bindings: {
            contract: "<"
        },
        controller: () => {},
        controllerAs: "ctrl"
    };
}

export const template = `
        <span>
            <span class="font-bold">{{ ctrl.contract.code.substring(0, 3) }}</span> |
            <span>{{ ctrl.contract.strike | strike : ctrl.contract.code.indexOf('XJO') == 0 }}</span>
            <span>{{ ctrl.contract.expiry | date:'MMM yy' }}</span>
            <span>{{ ctrl.contract.type | type }}</span>
            <span ng-if="ctrl.contract.style != null">
                &nbsp;&ndash;&nbsp;{{ctrl.contract.style | style}}
            </span>
        </span>
`;
